import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService, IEventType } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-select-item';

@Injectable({
    providedIn: 'root'
})
export class GtmEventSelectItemTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfGtmItemLinkClick') {
                this.dispatch(event, event.data);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, data: IEventType['dfGtmItemLinkClick']['data']) {
        return this.gtmService.dispatch({
            event: 'select_item',
            triggerContext: {
                trigger
            },
            ecommerce: await this.gtmDataService.getEventData([data])
        });
    }
}
